import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { LoginPage } from "../login/login";
import { SmartanimationProvider } from "../../providers/smartanimation/smartanimation";
//import { RestaurantslistPage } from "../restaurantslist/restaurantslist";
import { AuthProvider } from "../../providers/authservice/auth";
import { HomePage } from "../home/home";
import { WaiterDashboardPage } from "../waiter-dashboard/waiter-dashboard";
import { LoginServiceProvider } from '../../providers/authservice/loginService';
import { OpenTablesPage } from "../opentables/opentables";

@Component({
  selector: 'page-welcome',
  templateUrl: 'welcome.html',
})
export class WelcomePage implements OnInit {
  @ViewChild('welcomeAnimate') welcomeAnimate;
  server:any;
  constructor(
    public  navCtrl: NavController,
    public  navParams: NavParams,
    public  smartAnimation: SmartanimationProvider,
   
   // private iab: InAppBrowser,
    private authProvider: AuthProvider,
    private loginService:LoginServiceProvider
  ) {
   
    let user = JSON.parse(localStorage.getItem('UserId'));
    let userObj = JSON.parse(localStorage.getItem('UserObj'));
    console.log(user);
    console.log(userObj);

    if (userObj != undefined && userObj != null && userObj.clientId != null && userObj.clientId.length > 0) {
      this.navCtrl.setRoot(HomePage);
    }
    else if(userObj != null && userObj.waiterTo != null && userObj.waiterTo.length > 0){
       this.navCtrl.setRoot(WaiterDashboardPage)
    }
   
    else if (userObj != undefined && userObj != null) {
      if(userObj.clientId<=0 && this.navParams.get('initiator')){
        localStorage.removeItem('UserId');
        localStorage.removeItem('UserObj');
        localStorage.removeItem('chktok');
        this.loginService.logOut();
      }
      else
      this.navCtrl.setRoot(OpenTablesPage);
    }
  }
  ngOnInit() {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WelcomePage');
  }
  goToLogin() {
    this.navCtrl.setRoot(LoginPage);
  }

  guestLogin() {
    this.navCtrl.setRoot(OpenTablesPage);
  }
  signInWithGoogle() {
    this.authProvider.googleLogin()
      .then((res) => {
        console.log(res)
      })
      .catch((err) => console.log(err));
  }
  waiterDashboard(){
    this.navCtrl.push(WaiterDashboardPage);
  }
  ionViewWillEnter(){
    this.smartAnimation.smartAnimation().setType("fadeIn").show(this.welcomeAnimate.nativeElement);
  }
}



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.ts